import dayjs from 'dayjs';
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import lowerCase from 'lodash/lowerCase';

import {
  OPTIONS_ORDERING,
  PRICE_REPORT_FREQUENCIES,
} from './AnalyticalReport.constants';

export const transformReports = reports => {
  return reports.map(({ dates, downloadLink, frequency }) => {
    const dateObj = dates ? dayjs(dates) : dayjs();
    return {
      date: dateObj,
      hasValidDate: dateObj.isValid(),
      frequency,
      downloadLink,
      day: dateObj.format('DD'),
      monthAndYear: dateObj.format('MMM, YYYY'),
      label: dates,
    };
  });
};

export const getDropdownOptions = reports => {
  return compact(uniq(reports.map(report => report.frequency.trim()))).sort(
    (a, b) => {
      const loweredA = a.toLowerCase()[0];
      const loweredB = b.toLowerCase()[0];
      return OPTIONS_ORDERING[loweredA] - OPTIONS_ORDERING[loweredB];
    }
  );
};

export const filterReports = (reports, filter) => {
  return reports
    .filter(report => lowerCase(report.frequency) === lowerCase(filter))
    .sort((a, b) => (a.date.isAfter(b.date) ? -1 : 1));
};

export const getOptionLabel = option => {
  if (PRICE_REPORT_FREQUENCIES.includes(lowerCase(option))) {
    return `${option} price report`;
  }
  return option;
};
